import React from "react";
import SelectFieldCurriculum from "../../../../../../FormControl/SelectCustom/SelectFieldCurriculum";
import { useByStudent } from "../../ByStudentContext/ByStudentContext";
import { MarkingList } from "./MarkingList";
import Filters from "./Filters";

const CurrriculumSelector = () => {
  const { curriculumId, onCurriculumChange } = useByStudent();
  return (
    <div className="flex items-center gap-2 w-full justify-between">
      <div className="flex items-center gap-2 w-full justify-start">
        <SelectFieldCurriculum
          value={curriculumId}
          onChange={(e) => onCurriculumChange(e.target.value)}
        />
        { curriculumId && <Filters /> }
      </div>
      <MarkingList />
    </div>
  );
};

export default CurrriculumSelector;
